import React, { useState } from "react";

function CalculatorModal({ onClose }) {
  const [num1, setNum1] = useState('');
  const [num2, setNum2] = useState('');
  const [result, setResult] = useState(null);
  const [currency, setCurrency] = useState('$');

  const handleCalculate = (e) => {
    e.preventDefault();
    setResult(Number(num1) / Number(num2));
  };

  return (
    <form onSubmit={handleCalculate}>
      <div className="mb-3">
        <label className="form-label">Currency</label>
        <select
          className="form-control"
          value={currency}
          onChange={e => setCurrency(e.target.value)}
        >
          <option value="$">USD ($)</option>
          <option value="€">EUR (€)</option>
          <option value="£">GBP (£)</option>
          <option value="¥">JPY (¥)</option>
          <option value="₹">INR (₹)</option>
        </select>
      </div>
      <div className="mb-3">
        <label className="form-label">Total Bill Amount</label>
        <input
          type="number"
          className="form-control"
          value={num1}
          onChange={e => setNum1(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Number of People</label>
        <input
          type="number"
          className="form-control"
          value={num2}
          onChange={e => setNum2(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn btn-primary">Calculate</button>
      {result !== null && (
        <div className="alert alert-success mt-3">
          <strong>Each person pays: {currency}{result.toFixed(2)}</strong>
        </div>
      )}
    </form>
  );
}

export default CalculatorModal;


